"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var findFoldersService_1 = require("../../services/findFoldersService");
var store_1 = require("../../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var getMoveToDropdownFolders_1 = require("./getMoveToDropdownFolders");
var setFindFoldersRequestStatus_1 = require("./setFindFoldersRequestStatus");
var HIDDEN_FOLDER_EXTENDED_PROPERTY_TAG = '0x10f4';
/**
 * Makes the find folder service call and adds the folders to the create/edit inbox rule store
 */
exports.default = legacy_1.action('initializeInboxRulesFolders')(legacy_1.select({
    optionState: function () { return store_1.default; },
})(function initializeInboxRulesFolders(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rootFolderId, optionState;
        return tslib_1.__generator(this, function (_a) {
            rootFolderId = folderNameToId_1.default('msgfolderroot');
            optionState = state.optionState;
            setFindFoldersRequestStatus_1.default(1 /* Pending */);
            return [2 /*return*/, findFoldersService_1.default(rootFolderId)
                    .then(function (response) {
                    if (response.ResponseClass == 'Success') {
                        addFoldersFromFindFolder(optionState, response);
                        setFindFoldersRequestStatus_1.default(2 /* Complete */);
                    }
                })
                    .catch(function (error) {
                    setFindFoldersRequestStatus_1.default(3 /* Error */);
                    return;
                })];
        });
    });
}));
// VSTS 23155: Refactor load folders to not have pass by reference pattern
var addFoldersFromFindFolder = legacy_1.action('addFoldersFromFindFolder')(function addFoldersFromFindFolder(state, responseMessage) {
    var folderIds = [];
    var folders = new Map();
    var junkFolderId = folderNameToId_1.default('junkemail');
    // process all of the folders in the response
    responseMessage.RootFolder.Folders.forEach(function (item) {
        var folderId = item.FolderId.Id;
        addFolderToMap(item, folders);
        folderIds.push(folderId);
        if (folderId === junkFolderId) {
            state.junkFolderDisplayName = item.DisplayName;
        }
    });
    // process the ParentFolder from the response, and set it as the root
    addFolderToMap(responseMessage.RootFolder.ParentFolder, folders);
    var rootFolder = folders.get(responseMessage.RootFolder.ParentFolder.FolderId.Id);
    // set up all of the parent-child folder relations
    folderIds.forEach(function (folderId) {
        var folder = folders.get(folderId);
        var parentFolder = folders.get(folder.parentFolderId);
        if (parentFolder && !folder.isHidden) {
            parentFolder.childFolderIds.push(folderId);
        }
    });
    //create move to dropdown folder list
    state.dropdownFolders = getMoveToDropdownFolders_1.default(folders, rootFolder);
});
function addFolderToMap(item, folderMap) {
    var folder = {
        childFolderIds: [],
        displayName: item.DisplayName,
        folderId: item.FolderId.Id,
        folderType: item.__type,
        isHidden: getIsFolderHidden(item),
        parentFolderId: item.ParentFolderId.Id,
    };
    folderMap.set(folder.folderId, folder);
}
function getIsFolderHidden(item) {
    if (item.ExtendedProperty) {
        for (var i = 0; i < item.ExtendedProperty.length; i++) {
            var extendedProperty = item.ExtendedProperty[i];
            if (extendedProperty.ExtendedFieldURI.PropertyTag ===
                HIDDEN_FOLDER_EXTENDED_PROPERTY_TAG ||
                extendedProperty.ExtendedFieldURI.PropertyName ===
                    HIDDEN_FOLDER_EXTENDED_PROPERTY_TAG) {
                return JSON.parse(extendedProperty.Value);
            }
        }
    }
    return undefined;
}
//# sourceMappingURL=initializeInboxRulesFolders.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/initializeInboxRulesFolders.js
// module id = 5222
// module chunks = 2